import './About.css'

function About(){
    return(
        
        <div className="project">
        <div className="jumbotron jumbotron-fluid">
  <div className="container">
    <h1 className="display-4">About</h1>
    <p>About
I am a prolific full-stack developer who does competitive programming and enjoys contributing to an Open Source organization. I keep learning and improving myself. I admire contributing to the humanitarian organization to help as many people as possible. And I really like Problem Solving.</p>
    </div>
    </div>
    </div>
    )
}

export default About;